import React, { useEffect, useState } from 'react'
import { Page, PageContent, PageHeader, Grid, Layer, Spinner, Text } from 'grommet'
import { ReverseAnchor } from '../components/competetive/ReverseAnchor';
import { CustomCard } from '../components/competetive/CustomCard';
import { useParams } from 'react-router-dom/cjs/react-router-dom';
import { useSelector, useDispatch } from "react-redux";
import { analyticsService, competetiveService } from '../services';
import { competetiveActions } from '../redux/actions/competetiveActions';
import { LogCompetitiveEvents } from '../redux/constants/logEvents';


function CompetitorBattleCards() {
    const { product_id, res_id } = useParams()
    const dispatch = useDispatch();
    const [pageTitle, setPageTitle] = useState('')
    const [anchorTitle, setAnchorTitle] = useState('')
    const session = useSelector((state) => {
        return state.session;
    });
    useEffect(() => {
        if (session && session.user && session.user.access) {
            competetiveService.getCompetitorProductById(session.user.access, product_id).then((response) => {
                setAnchorTitle(response.competitor_product_group)
                setPageTitle(response.competitor_product_name + ' Resources')
            })
            dispatch(competetiveActions.getResources(product_id, 1, session.user.access))
        }
    }, [
        session,
        dispatch, res_id, product_id]);

    useEffect(() => {

    }, [res_id, product_id,])
    const resourceList = useSelector((state) => {
        return state.competitiveProducts.resources
    });

    return <>
        <Page>
            <PageContent>
                {resourceList.requestInProgress &&
                    <Layer position='center' background='none' style={{ boxShadow: "none" }}>
                        <Spinner />
                    </Layer>
                }

                {
                    <>
                        <PageHeader parent={<ReverseAnchor label={anchorTitle} onClick={() => { window.history.go(-1) }} />} title={pageTitle}
                        />
                        {resourceList && Array.isArray(resourceList.data) && resourceList.data.length > 0 ? <Grid columns={"25%"} gap={"medium"}>
                            {
                                resourceList.data.map((resource, index) => (
                                    <CustomCard key={`${index}_${resource.resource_title}`} title={resource.resource_title} description={resource.resource_content_type} border={true} color={resource.resource_content_type_color} onClickHandler={() => {
                                        window.open(resource.link)
                                        analyticsService.logCompetitiveEvent(session.user.access, LogCompetitiveEvents.RESOURCES, null, product_id, null, resource.id)
                                    }} />
                                ))
                            }
                        </Grid> : resourceList.requestInProgress ? <Spinner /> : <Text> No Resources available for the selected product</Text>}
                    </>
                }
            </PageContent>
        </Page>
    </>
}

export default CompetitorBattleCards